export default "/KeyArt_landscape.1f50f492-927eea.jpg";